import { type ListingProduct, ListingProductCode } from 'src/generated/graphql';

interface ExperimentListingPackageInfo {
  productCode: ListingProduct['productCode'];
  description: string;
  features: string[];
}

const experimentListingProducts = [
  {
    productCode: ListingProductCode.ListUntilSold,
    description: 'Standard List Until Sold ad',
    features: [
      "Appear on Australia's #1 business marketplace",
      'List until your business sells',
      'Connect with interested buyers',
      'Photo included in search results',
      'Appear higher in search results',
      'Included in daily buyer recommendation emails',
    ],
  },
  {
    productCode: ListingProductCode.Accelerate,
    description: 'Accelerate List Until Sold ad',
    features: [
      "Appear on Australia's #1 business marketplace",
      'List until your business sells',
      'Connect with interested buyers',
      'Photo included in search results',
      'Appear higher in search results',
      'Feature at the top of search results',
      'Included in daily buyer recommendation emails',
      'Priority placement in daily buyer recommendation emails',
    ],
  },
] satisfies ExperimentListingPackageInfo[];

export const getCheckoutProductInfo = (listingProduct: ListingProduct) =>
  experimentListingProducts.find(
    (x) => x.productCode === listingProduct.productCode,
  )!;
